module.exports = {
	props: {
		/**
		 * Toggles the adding of a 'loading' class to the main
		 * .v-select wrapper. Useful to control UI state when
		 * results are being processed through AJAX.
		 */
		loading: {
			type: Boolean,
			default: false
		},

		/**
		 * Accept a callback function that will be
		 * run when the search text changes.
		 *
		 * loading() accepts a boolean value, and can
		 * be used to toggle a loading class from
		 * the onSearch callback.
		 *
		 * @param {search}  String          Current search text
		 * @param {loading} Function(bool)  Toggle loading class
		 */
		onSearch: {
			type: Function,
			default: function (search, loading) {
			}
		}
	},

	data() {
		return {
			mutableLoading: false,
			loadingMore: false,
			numberOfPageLoaded: 0
		}
	},

	watch: {
		/**
		 * If a callback & search text has been provided,
		 * invoke the onSearch callback.
		 */
		search() {
			this.typeAheadPointer = 0
			if (true || this.search.length > 0) {
				if(this.search.length > 0 && !this.isContext) {
					this.$emit('textUpdate', this.search)
					this.$emit('keyUpdate', null)
					this.$emit('input', null)
				}

				this.onSearch(this.search, this.toggleLoading, 0, this.toggleLoadingMore)
				this.$emit('search', this.search, this.toggleLoading, 0,this.toggleLoadingMore)
			}
		},
		/**
			 * Sync the loading prop with the internal
			 * mutable loading value.
		 * @param val
		 */
		loading(val) {
			this.mutableLoading = val
		},
		open() {
			if (this.open) {
				console.log('open...')
				this.$emit('search', this.search, this.toggleLoading, 0, this.toggleLoadingMore)
			}
		}
	},

	methods: {
		loadMore() {
			// console.log(this.$refs.dropdownMenu ? this.$refs.dropdownMenu.scrollHeight: 0)
			// console.log(this.$refs.dropdownMenu ? this.$refs.dropdownMenu.offsetHeight: 0)
			// console.log(this.getDropdownViewport())
			// console.log(this.$refs.dropdownMenu ? this.$refs.dropdownMenu.scrollTop: 0)
			const el = this.$refs.dropdownMenu;
			if (el && !this.loadingMore) {
				const { scrollTop, scrollHeight, clientHeight } = el;
				if (scrollTop + clientHeight >= scrollHeight - 60) {
					this.numberOfPageLoaded = this.numberOfPageLoaded + 1;
					this.onSearch(this.search, this.toggleLoading, this.numberOfPageLoaded, this.toggleLoadingMore);
					this.$emit('search', this.search, this.toggleLoading, this.numberOfPageLoaded, this.toggleLoadingMore);
				}
			}
		},
		/**
		 * Toggle this.loading. Optionally pass a boolean
		 * value. If no value is provided, this.loading
		 * will be set to the opposite of it's current value.
		 * @param toggle Boolean
		 * @returns {*}
		 */
		toggleLoading(toggle = null) {
			if (toggle == null) {
				return this.mutableLoading = !this.mutableLoading
			}
			return this.mutableLoading = toggle
		},
		toggleLoadingMore(toggle = null) {
			if (toggle == null) {
				return this.loadingMore = !this.loadingMore
			}
			return this.loadingMore = toggle
		}
	}
}
